module.exports = {
  "listingLibInteraction": {
    "name": "listing-lib-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-content-link-edit"
      ]
    },
    "namespace": "content-management-listing-lib",
    "version": "1"
  }
};